var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-container" },
    [
      _c(
        "form-wrapper",
        { staticClass: "modal-form", attrs: { validator: _vm.$v.rateDetail } },
        [
          _c("header", { staticClass: "modal-header" }, [
            _c(
              "div",
              { staticClass: "modal-header__right" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-simple md-just-icon md-round",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$modal.hide($event)
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("clear")])],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c(
              "div",
              { staticClass: "section-override" },
              [
                _c(
                  "md-switch",
                  {
                    model: {
                      value: _vm.rateDetail.overrideRule,
                      callback: function ($$v) {
                        _vm.$set(_vm.rateDetail, "overrideRule", $$v)
                      },
                      expression: "rateDetail.overrideRule",
                    },
                  },
                  [_vm._v("\n                   Override\n                ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "section-heading" }, [
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Timeframe"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v("Choose the active window for this rule."),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "section-card section-card--wide" },
              [
                _c("rule-valid-days", {
                  ref: "ruleValidDays",
                  attrs: {
                    "current-days": _vm.rateDetail.validForWeekDays,
                    "from-date": _vm.rateDetail.validFromDate,
                    "to-date": _vm.rateDetail.validToDate,
                  },
                  on: { daysSelected: _vm.handleDaysSeleceted },
                }),
              ],
              1
            ),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c("div", { staticClass: "section-heading" }, [
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Charges"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v("Set levy amounts and any related commissions."),
              ]),
            ]),
            _c("div", { staticClass: "section-card section-card--compact" }, [
              _c("div", { staticClass: "charging-grid" }, [
                _c(
                  "div",
                  { staticClass: "charging-group" },
                  [
                    _c("h5", { staticClass: "charging-group__title" }, [
                      _vm._v("Fuel levy"),
                    ]),
                    _c("p", { staticClass: "charging-group__hint" }, [
                      _vm._v(
                        "Apply the primary levy percentage for this rule."
                      ),
                    ]),
                    _c(
                      "form-group",
                      {
                        attrs: {
                          name: "fuelLevyPercentage",
                          label: "Fuel Levy Percentage",
                        },
                      },
                      [
                        _vm.$_nullChecker(_vm.rateDetail.fuelLevyPercentage)
                          ? _c("rule-operator", {
                              attrs: {
                                value:
                                  _vm.rateDetail.fuelLevyPercentage.operator,
                              },
                              model: {
                                value:
                                  _vm.rateDetail.fuelLevyPercentage.operator,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.rateDetail.fuelLevyPercentage,
                                    "operator",
                                    $$v
                                  )
                                },
                                expression:
                                  "rateDetail.fuelLevyPercentage.operator",
                              },
                            })
                          : _vm._e(),
                        _c("md-input", {
                          model: {
                            value: _vm.rateDetail.fuelLevyPercentage.value,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.rateDetail.fuelLevyPercentage,
                                "value",
                                _vm._n($$v)
                              )
                            },
                            expression: "rateDetail.fuelLevyPercentage.value",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", {
                  staticClass: "charging-separator",
                  attrs: { "aria-hidden": "true" },
                }),
                _c(
                  "div",
                  { staticClass: "charging-group" },
                  [
                    _c("h5", { staticClass: "charging-group__title" }, [
                      _vm._v("Futile charge"),
                    ]),
                    _c("p", { staticClass: "charging-group__hint" }, [
                      _vm._v(
                        "Optional once-off amount when a job cannot be completed."
                      ),
                    ]),
                    _c(
                      "form-group",
                      {
                        attrs: { name: "futileCharge", label: "Futile Charge" },
                      },
                      [
                        _vm.$_nullChecker(_vm.rateDetail.futileCharge)
                          ? _c("rule-operator", {
                              attrs: {
                                value: _vm.rateDetail.futileCharge.operator,
                              },
                              model: {
                                value: _vm.rateDetail.futileCharge.operator,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.rateDetail.futileCharge,
                                    "operator",
                                    $$v
                                  )
                                },
                                expression: "rateDetail.futileCharge.operator",
                              },
                            })
                          : _vm._e(),
                        _c("md-input", {
                          attrs: { type: "number" },
                          model: {
                            value: _vm.rateDetail.futileCharge.value,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.rateDetail.futileCharge,
                                "value",
                                _vm._n($$v)
                              )
                            },
                            expression: "rateDetail.futileCharge.value",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.driverRuleCreation
                  ? _c("div", {
                      staticClass: "charging-separator",
                      attrs: { "aria-hidden": "true" },
                    })
                  : _vm._e(),
                _vm.driverRuleCreation
                  ? _c(
                      "div",
                      { staticClass: "charging-group" },
                      [
                        _c("h5", { staticClass: "charging-group__title" }, [
                          _vm._v("Driver commission"),
                        ]),
                        _c("p", { staticClass: "charging-group__hint" }, [
                          _vm._v(
                            "Commission percentage applied when allocating to drivers."
                          ),
                        ]),
                        _c(
                          "form-group",
                          {
                            attrs: {
                              name: "driverCommission",
                              label: "Commission Percentage",
                            },
                          },
                          [
                            _vm.$_nullChecker(_vm.rateDetail.driverCommission)
                              ? _c("rule-operator", {
                                  attrs: {
                                    value:
                                      _vm.rateDetail.driverCommission.operator,
                                  },
                                  model: {
                                    value:
                                      _vm.rateDetail.driverCommission.operator,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rateDetail.driverCommission,
                                        "operator",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "rateDetail.driverCommission.operator",
                                  },
                                })
                              : _vm._e(),
                            _c("md-input", {
                              model: {
                                value: _vm.rateDetail.driverCommission.value,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.rateDetail.driverCommission,
                                    "value",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "rateDetail.driverCommission.value",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c("div", { staticClass: "section-heading" }, [
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Coverage"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v(
                  "Control whether the levy automatically includes all surcharges."
                ),
              ]),
            ]),
            _c("div", { staticClass: "section-card section-card--compact" }, [
              _c(
                "div",
                { staticClass: "switch-row" },
                [
                  _c("div", { staticClass: "switch-row__copy" }, [
                    _c("h6", { staticClass: "charging-group__title" }, [
                      _vm._v("Include all surcharges"),
                    ]),
                    _c("p", { staticClass: "charging-group__hint" }, [
                      _vm._v(
                        "Enable when fuel levy should cover any additional surcharges."
                      ),
                    ]),
                  ]),
                  _c(
                    "md-switch",
                    {
                      model: {
                        value: _vm.rateDetail.fuelLevyIncludesAllCharges,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.rateDetail,
                            "fuelLevyIncludesAllCharges",
                            $$v
                          )
                        },
                        expression: "rateDetail.fuelLevyIncludesAllCharges",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        Include all surcharges\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("footer", { staticClass: "modal-footer" }, [
            _c(
              "div",
              { staticClass: "modal-footer__actions" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-default dialog-button",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$modal.hide($event)
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
                _c(
                  "md-button",
                  {
                    staticClass: "md-primary dialog-button",
                    on: {
                      click: function ($event) {
                        return _vm.create()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.isUpdate ? "Update" : "Create") +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }